export interface CreateSchoolStatisticsAdvancementListRequest {
  users: {
    id: string
    newStudentGrade: string
    newStudentClass: string
    newStudentNumber: string
  }[]
}

export function CreateSchoolStatisticsAdvancementListRequestToJSON(
  value: CreateSchoolStatisticsAdvancementListRequest
): any {
  return {
    users:
      value.users.length > 0
        ? value.users.map(user => ({
            id: user.id !== '' ? user.id : undefined,
            new_student_grade:
              user.newStudentGrade !== '' ? user.newStudentGrade : undefined,
            new_student_class:
              user.newStudentClass !== '' ? user.newStudentClass : undefined,
            new_student_number:
              user.newStudentNumber !== '' ? user.newStudentNumber : undefined
          }))
        : undefined
  }
}
